__turbopack_context__.v({
  "buttons": "FreeTrialActiveModal-module__rKeBgG__buttons",
  "closeBtnWrapper": "FreeTrialActiveModal-module__rKeBgG__closeBtnWrapper",
  "contentWrapper": "FreeTrialActiveModal-module__rKeBgG__contentWrapper",
  "expiration": "FreeTrialActiveModal-module__rKeBgG__expiration",
  "expirationContent": "FreeTrialActiveModal-module__rKeBgG__expirationContent",
  "icon": "FreeTrialActiveModal-module__rKeBgG__icon",
  "main": "FreeTrialActiveModal-module__rKeBgG__main",
});
